<template>
  <HeroSection title="Reviews" bg-src="/images/reviews-bg.webp">
    <div class="flex flex-wrap justify-center pb-4 gap-x-4">
      <a v-for="link in moreReviewslinks" :href="link.href" target="_blank" class="flex items-center">
        {{ link.title }}
        &nbsp;
        <UIcon v-for="i in Array(link.stars)" name="i-heroicons-star-solid" />
        ({{ link.reviewsAmount }})
      </a>
    </div>
  </HeroSection>

  <section class="relative py-24">
    <div class="relative px-6 mx-auto max-w-7xl lg:px-8">
      <div class="max-w-xl mx-auto text-center">
        <h1 class="font-semibold leading-8" id="reviews">Tripadvisor reviews</h1>
      </div>
      <ContentReviewsBlocks v-for="testimonialsPage in testimonialsPages" :five-testimonials="testimonialsPage" />
    </div>

    <div class="container flex flex-wrap items-center justify-center py-10 gap-y-5 gap-x-10">
      <h3 class="m-0">More reviews on:</h3>
      <div class="flex flex-wrap justify-center gap-x-4">
        <a v-for="link in moreReviewslinks" :href="link.href" target="_blank" class="flex items-center">
          {{ link.title }}
          &nbsp;
          <UIcon v-for="i in Array(link.stars)" name="i-heroicons-star-solid" />
          ({{ link.reviewsAmount }})
        </a>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script setup lang="ts">
const { data: testimonialsPages } = await useAsyncData(async () => {
  return useTestimonials().reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / 5)

    if(!resultArray[chunkIndex]) resultArray[chunkIndex] = []
    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])
})

const moreReviewslinks = useMoreReviewsLinks()
</script>
